import sidebar from './sidebar.vue'

const Plugin = {
  install (Vue, options = {}) {
    if (this.installed) {
      return
    }
    this.installed = true
    this.event = new Vue()

    Vue.component(sidebar.name, sidebar)
    // Vue.mixin({
    // })

    Vue.prototype.$sidebar = {
      toggle (bool) {
        Plugin.event.$emit('toggle', bool)
      },
      set (offsetHeight = 0, offsetTop = 0) {
        Plugin.event.$emit('set', {
          offsetHeight,
          offsetTop
        })
      },
      focus (target) {
        Plugin.event.$emit('focus', target)
      }
    }
  }
}

// This exports the plugin object.
export default Plugin
